module.exports = __webpack_public_path__ + "static/SatoPrinter-7c1f31e626b700c2968225be07220792.jpg";